export const EXPIRED_SHARE_LINK_MESSAGE =
  'This link has either expired or does not exist.';
